import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { occasionLabel, occasionKeyFromQueryValue } from '../../../data/occasions';
import css from './MainPanelHeader.module.css';

const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    isSortByActive,
    listingsAreLoaded,
    resultsCount,
    searchInProgress = false,
    noResultsInfo,
    currentCategory,
    activeKeyword = null,
    onClearKeyword,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const categoryLabel = currentCategory
    ? occasionLabel(occasionKeyFromQueryValue(currentCategory))
    : null;

  // Active keyword chip — a ?keywords= search used to be completely
  // invisible on this page (audit P1): no echo, no way to clear it.
  const keywordChip = activeKeyword ? (
    <button
      type="button"
      className={css.keywordChip}
      onClick={onClearKeyword}
      title="Clear keyword"
    >
      &ldquo;{activeKeyword}&rdquo; <span aria-hidden="true">&times;</span>
    </button>
  ) : null;

  return (
    <div className={classes}>
      {/* Breadcrumb */}
      {categoryLabel && (
        <nav className={css.breadcrumb}>
          <a href="/" className={css.breadcrumbLink}>Home</a>
          <span className={css.breadcrumbSep}>/</span>
          <a href="/s" className={css.breadcrumbLink}>Browse</a>
          <span className={css.breadcrumbSep}>/</span>
          <span className={css.breadcrumbCurrent}>{categoryLabel}</span>
        </nav>
      )}

      {/* Category title + result count + sort */}
      {categoryLabel && (
        <div className={css.titleRow}>
          <h1 className={css.categoryTitle}>{categoryLabel} Kits</h1>
          <div className={css.titleRight}>
            <span className={css.resultsCount}>
              {searchInProgress ? (
                <FormattedMessage id="MainPanelHeader.loadingResults" />
              ) : (
                <>{resultsCount} {resultsCount === 1 ? 'kit' : 'kits'}</>
              )}
            </span>
            {keywordChip}
            {isSortByActive ? sortByComponent : null}
          </div>
        </div>
      )}

      {/* Results bar with sort */}
      {!categoryLabel && (
        <div className={css.searchOptions}>
          <h1 className={css.searchResultSummary}>
            <span className={css.resultsFound}>
              {searchInProgress ? (
                <FormattedMessage id="MainPanelHeader.loadingResults" />
              ) : (
                <FormattedMessage
                  id="MainPanelHeader.foundResults"
                  values={{ count: resultsCount }}
                />
              )}
            </span>
          </h1>
          {keywordChip}
          {isSortByActive ? (
            <div className={css.sortyByWrapper}>
              <span className={css.sortyBy}>
                <FormattedMessage id="MainPanelHeader.sortBy" />
              </span>
              {sortByComponent}
            </div>
          ) : null}
        </div>
      )}

      {children}

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

export default MainPanelHeader;
